import { render, staticRenderFns } from "./productAttributes.vue?vue&type=template&id=99066900&scoped=true"
import script from "./productAttributes.vue?vue&type=script&lang=js"
export * from "./productAttributes.vue?vue&type=script&lang=js"
import style0 from "./productAttributes.vue?vue&type=style&index=0&id=99066900&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99066900",
  null
  
)

export default component.exports